import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
// import AccountCircle from '@material-ui/icons/AccountCircle';
// import MenuItem from '@material-ui/core/MenuItem';
import ArrowBack from '@material-ui/icons/ArrowBack';
// import Menu from '@material-ui/core/Menu';
import { Container } from '@material-ui/core';
import Chart from './Chart';
//
import api from '../api/coins/bitcoin7d.json'

//color
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

const dataCoin = api.data

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    chart: {
        margin: 40,
        width: '100%',
        textAlign: 'center'
    },
    pos: props => ({
        marginBottom: 12,
        color: props.color,
    }),
}));

export default function MenuAppBar() {
    const props = { color: dataCoin.coin.change > 0 ? green[500] : red[500] }

    const classes = useStyles(props);
    // const [auth, setAuth] = React.useState(true);
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open = Boolean(anchorEl);

    // function handleChange(event) {
    //     setAuth(event.target.checked);
    // }

    // function handleMenu(event) {
    //     setAnchorEl(event.currentTarget);
    // }

    // function handleClose() {
    //     setAnchorEl(null);
    // }

    return (
        <div className={classes.root}>
            <AppBar position="static" color="white">
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Menu">
                        {/* <MenuIcon /> */}
                        <ArrowBack />
                    </IconButton>
                    <img src={dataCoin.coin.iconUrl} alt={dataCoin.coin.name} width='50' className={classes.menuButton} />
                    <Typography variant="h6" className={classes.title}>
                        {dataCoin.coin.name}
                    </Typography>
                    <div>
                        <Typography variant="h6" className={classes.title}>
                            {dataCoin.base.sign} {parseFloat(dataCoin.coin.price).toFixed(2)}
                        </Typography>
                    </div>
                </Toolbar>
            </AppBar>

            <Container className={classes.chart}>
                <Typography variant="h6" className={classes.pos}>
                    {
                        dataCoin.coin.change > 0 ?
                            <>
                                + {dataCoin.coin.change}
                            </>
                            :
                            <>
                                {/* <TrendingDown className={classes.iconPos} /> */}
                                {/* <ArrowDownward className={classes.iconPos} /> */}
                                - {dataCoin.coin.change * -1}
                            </>
                    } %
                </Typography>
                <Chart history={dataCoin.history} />
            </Container>

        </div>
    );
}